var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWantBetter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 115,
    viewBox: "0 0 115 115",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_126_595",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 115,
    height: 115
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 115,
    height: 115,
    rx: 57.5,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_126_595)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 115,
    height: 115,
    fill: "url(#paint0_radial_126_595)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.2523 93.7239C56.4034 98.4184 44.2577 99.8353 34.3994 97.8503C27.8428 90.3467 22.4736 77.4664 25.2675 72.8672C28.0614 68.268 37.8013 52.818 37.8013 52.818L48.2886 58.6535L50.4712 54.0131L63.4616 61.5131L60.6082 65.5353L71.5039 71.5834C71.5039 71.5834 62.0716 89.0007 59.2523 93.7239ZM77.9218 37.8072L74.9385 43.1746L72.7041 41.8846L63.7041 57.4731L54.7666 51.7934L63.356 36.476L60.8879 35.051L64.165 30.0148C61.769 25.7448 61.3857 20.1887 64.7646 14.5763L68.1197 9.58511L93.5533 23.7727L90.9708 28.8058C87.5064 34.9462 82.6473 37.6025 77.9218 37.8072ZM70.7307 21.5426C67.0407 27.9339 77.4327 34.8344 81.6891 27.4422L70.7307 21.5426Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_126_595",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(90.0808 9.94569) rotate(123.422) scale(114.728 172.569)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A6BFF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWantBetter);
export default __webpack_public_path__ + "static/media/want-better.0f0e8cee40c3683753dc887e56191b83.svg";
export { ForwardRef as ReactComponent };